module.exports = __webpack_public_path__ + "img/botella_black_label_1.9cdf727d.png";